import { useSelector } from 'react-redux';
import { RootState } from 'states/index';

export const useToast = () => {
  return useSelector<RootState, RootState['toast']>((state) => state.toast);
};
